import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminManageCourtsPage = React.lazy(() => import(/* webpackChunkName: "AdminManageCourts" */ './Page'));
export const AdminManageCourts = () => (React.createElement(Page, { title: "Administrator Manage Courts" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminManageCourtsPage, null)))));
